export default __webpack_public_path__ + "static/media/customer_image.0dc08cf0.png";